import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Dispatch } from '../../../../store/store';
import { connect } from 'react-redux';
import { CheckboxItem } from '../../../../components/Checkboxes/CheckboxItem';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import EmptyDataTable from '../../../../components/EmptyDataTable/EmptyDataTable';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../constants/common';

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = ReturnType<typeof mapDispatch>;
type ComponentProps = StateProps & DispatchProps;

const SystemFaultsView: React.FC<ComponentProps> = ({ getSettings, reset }) => {
  const { id } = useParams();
  const [faults, setFaults] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);

    const { controller_settings } = await getSettings(id);
    setFaults(controller_settings.faults.value);
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, EXTENDED_INTERVAL_UPDATE_DATA);
    return () => clearInterval(intervalId);
  }, [fetchData]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  if (!faults.length) {
    return (
      <div className="p-edit-controller-system-faults pb-4 md:pb-25">
        <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
          <div className="border-b border-stroke px-7 py-4 dark:border-strokedark">
            <h3 className="font-medium text-black dark:text-white">Controller System Faults</h3>
          </div>
          {loading ? (
            <div className="flex h-full w-full items-center justify-center py-10">
              <SpinnerLoader />
            </div>
          ) : (
            <div className="flex h-full w-full flex-col gap-3.5 p-10">
              <EmptyDataTable />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="p-edit-controller-system-faults pb-4 md:pb-25">
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="border-b border-stroke px-7 py-4 dark:border-strokedark">
          <h3 className="font-medium text-black dark:text-white">Controller System Faults</h3>
        </div>

        <div className="flex w-full flex-row justify-between p-7">
          <div className="flex w-full flex-col justify-start">
            <div className="flex w-full flex-row justify-start gap-5.5">
              {faults.map((fault) => {
                return <CheckboxItem key={fault} text={fault} defaultChecked checked />;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapState = () => ({});

const mapDispatch = (dispatch: Dispatch) => ({
  getSettings: dispatch.controllers.getControllerSettings,
  reset: dispatch.controllers.resetSettings,
});

export const SystemFaults = connect(mapState, mapDispatch)(SystemFaultsView);
